import React from "react";

export default function ProductItem({ product, onEdit, onDelete, isExpanded, onToggle }) {
  return (
    <div className={`product-item ${isExpanded ? "expanded" : ""} animate-fade-in`}>
      {/* Primary Data Row Section */}
      <div className="product-main" onClick={onToggle}>
        <div className="col code">
          <span className="code-badge">{product.code}</span>
        </div>
        
        <div className="col qty">
          <span className={`qty-pill ${product.quantity <= 5 ? "low-stock" : ""}`}>
            {product.quantity}
          </span>
        </div>
        
        <div className="col desc">
          <span className="desc-text">{product.description}</span>
        </div>
        
        <div className="col cust">
          <span className="label-text">{product.customer}</span>
        </div>
        
        <div className="col supplier">
          <span className="label-text">{product.supplier}</span>
        </div>
        
        <div className="expand-indicator">
          <span>▼</span>
        </div>
      </div>

      {/* Accordion Expandable Action Section */}
      {isExpanded && (
        <div className="product-actions">
          <div className="action-label">Management Options</div>
          <div className="button-group">
            <button className="edit-btn" onClick={(e) => { e.stopPropagation(); onEdit(product); }}>
              <span className="btn-icon">📝</span> Edit Product
            </button>
            <button className="delete-btn" onClick={(e) => { e.stopPropagation(); onDelete(product); }}>
              <span className="btn-icon">🗑️</span> Delete Permanent
            </button>
          </div>
        </div>
      )}
    </div>
  );
}